import {
    Card,
    CardHeader,
    Grid,
    Divider,
    CardContent,
    Stack, Alert
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import React, {useEffect, useState} from "react";
import AddIcon from "@mui/icons-material/Add";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import {useNavigate} from "react-router-dom";
import {Icon} from "@iconify/react";
import {HttpSolicitationFlow} from "../../../http/flow/httpFlow";
import DeleteDialog from "../../../components/dialog/DeleteDialog";
import {ClientSolicitationFlow} from "../../../types/flow/flowData";
import DialogNewEconomicSituation from "./components/components-economic-situation/DialogNewEconomicSituation";
import CompanyEconomicSituationDataGrid
    from "./components/components-economic-situation/CompanyEconomicSituationDataGrid";
import {HttpSolicitationOnboarding} from "../../../http/solicitation/httpSolicitationOnboarding";
import toast from "react-hot-toast";
import {MiddleStepProps} from "../index";

interface StepCompanyEconomicSituationProps extends MiddleStepProps{
    isPhysical: boolean;
    monotax: boolean;
}


const StepCompanyEconomicSituation = ({ handleNext, handlePrev, clientSolicitationId, isPhysical, monotax }: StepCompanyEconomicSituationProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const [flows, setFlows] = useState<ClientSolicitationFlow[]>([])
    const [flowDeleteId, setFlowDeleteId] = useState<number>()
    const [flowEdit, setFlowEdit] = useState<ClientSolicitationFlow>()
    const [openDelete, setOpenDelete] = useState<boolean>(false)
    const navigate = useNavigate()
    
    const onEdit = (flow: ClientSolicitationFlow) => {
        setFlowEdit(flow)
        setOpen(true)
    }
    
    const onDelete = (flowId: number) => {
        setFlowDeleteId(flowId)
        setOpenDelete(true)
    }
    
    const loadFlows = () => {
        HttpSolicitationFlow.getList(clientSolicitationId).then((r) => {
            setFlows(r)
            setFlowEdit(undefined)
        })
    }
    
    useEffect(() =>  {
        loadFlows()
    }, [])
    
    const onDeleteFlow = () => {
        if (flowDeleteId) 
            HttpSolicitationFlow.delete(clientSolicitationId, flowDeleteId).then(() => loadFlows())
    }
    
    const onNext = () => {
        HttpSolicitationOnboarding.getStepResult(clientSolicitationId, 4)
            .then((r) => {
                if (!r.tieneError) handleNext()
                else {
                    toast.error(r.descripcionError)
                }
            })
    }

    useEffect(() => {
        if (monotax) onNext()
    }, [monotax]);
    
    //ya si no es monotributo, se ejecuta el render
    
    return (
        <Card>
            <CardHeader title={"Situación económica de la empresa"}
                action={
                <Stack direction={'row'} alignItems={'center'} spacing={2}>
                    <Button color='primary' variant='contained' onClick={() => { setOpen(true) }} startIcon={<AddIcon />}>Nuevo movimiento</Button>
                    <Button color='secondary' variant='contained' onClick={() => navigate('/solicitudes')} startIcon={<KeyboardBackspaceOutlinedIcon/>}>
                        Inicio
                    </Button>
                </Stack>
            }
            />
            <Divider />
            <CardContent>
                <Alert severity={'info'} sx={{mb: 3}}>
                    {isPhysical ? 'Completar todos los periodos posteriores al cierre de la última DDJJ'
                        : 'Completar todos los periodos posteriores al cierre de los últimos Estados Contables'}
                </Alert>
                <Grid container spacing={3} justifyContent={'center'}>
                    <Grid item xs={12}>
                        <CompanyEconomicSituationDataGrid flows={flows} onEdit={onEdit} onDelete={onDelete}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button color='secondary' variant='contained' onClick={handlePrev} startIcon={<Icon icon='mdi:chevron-left' fontSize={20} />}>
                                Atrás
                            </Button>
                            <Button variant='contained' color='primary' onClick={onNext} endIcon={<Icon icon='mdi:chevron-right' fontSize={20} />}>
                                Siguiente
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
                <DialogNewEconomicSituation open={open}
                                            onClose={() => {
                                                setOpen(false)
                                                setFlowEdit(undefined)
                                            }}
                                            onSubmit={loadFlows}
                                            solicitationId={clientSolicitationId}
                                            flowEdit={flowEdit}
                />
                <DeleteDialog open={openDelete}
                              onClose={() => {
                                  setOpenDelete(false)
                              }}
                              onDelete={onDeleteFlow}
                              title={'Eliminar movimiento'}
                              description={'¿Está seguro de querer eliminar el movimiento?'}
                />
            </CardContent>
        </Card>
    )
}


export default StepCompanyEconomicSituation